export function needAbsoluteValueEvolution(
  annotationType: string,
  annotationValue: string,
): boolean {
  if (annotationType === "QUANTITY") {
    if (annotationValue === "measured" || annotationValue === "expected") {
      return false;
    }
  }
  if (annotationType === "FAULT") {
    if (annotationValue === "real") {
      return false;
    }
  }
  return true;
}
